import Reports from './Reports'

export default Reports



// WEBPACK FOOTER //
// ./src/components/Reports/index.js